import { render, staticRenderFns } from "./MaterialsFilter.vue?vue&type=template&id=93e852ae&scoped=true"
import script from "./MaterialsFilter.vue?vue&type=script&lang=js"
export * from "./MaterialsFilter.vue?vue&type=script&lang=js"
import style0 from "./MaterialsFilter.vue?vue&type=style&index=0&id=93e852ae&prod&lang=scss&scoped=true"
import style1 from "./MaterialsFilter.vue?vue&type=style&index=1&id=93e852ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e852ae",
  null
  
)

export default component.exports